import { render, staticRenderFns } from "./FabricaList.vue?vue&type=template&id=14236553&scoped=true"
import script from "./FabricaList.vue?vue&type=script&lang=js"
export * from "./FabricaList.vue?vue&type=script&lang=js"
import style0 from "./FabricaList.vue?vue&type=style&index=0&id=14236553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14236553",
  null
  
)

export default component.exports